// External
import React from 'react';
import { func, string, bool } from 'prop-types';
import { Close } from '@nike/nike-design-system-icons';
import { useTokens } from '@nike/nike-design-system-components';
import styled from '@emotion/styled';

import { btnBorderRadius } from '../styles/critical/variables';

export const BadgeButton = styled.button`
  position: absolute;
  right: 4px;
  top: 4px;
  background-color: transparent;
`;

export const Badge = styled.span`
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-radius: ${({ borderRadius }) => borderRadius};
  color: ${({ fontColor }) => fontColor};
  display: ${({ display }) => display};
  height: auto;
  margin: 5px;
  padding: 6px 12px;
  padding-right: ${({ onClose }) => !!onClose && '40px'};
  position: relative;
  width: ${({ width }) => width};
`;

/* @description Used in the Catalogs tool for Catalog Types and Add Products to Catalog */
const BadgeStyled = ({ text, onClose, error, display, borderRadius, backgroundColor, fontColor, width }) => {
  const tokens = useTokens();

  // use provided colors, or default to design tokens
  const defaultBackgroundColor = backgroundColor || tokens.podiumCdsColorWhite;
  const defaultFontColor = fontColor || tokens.podiumCdsColorBlack;

  // override colors if there's an error
  const backgroundColorOverride = error ? tokens.podiumCdsColorCritical : defaultBackgroundColor;
  const fontColorOverride = error ? tokens.podiumCdsColorWhite : defaultFontColor;

  return (
    <Badge
      backgroundColor={backgroundColorOverride}
      borderRadius={borderRadius}
      data-testid={`badge${error ? '-error' : ''}`}
      display={display}
      error={error}
      fontColor={fontColorOverride}
      onClose={onClose}
      tokens={tokens}
      width={width}
    >
      {text}
      {onClose && (
        <BadgeButton onClick={onClose} data-testid='badgeCloseIcon'>
          <Close color={fontColorOverride} size='s' />
        </BadgeButton>
      )}
    </Badge>
  );
};

BadgeStyled.defaultProps = {
  backgroundColor: '',
  borderRadius: btnBorderRadius,
  display: 'block',
  error: false,
  fontColor: '',
  onClose: null,
  text: '',
  width: 'auto'
};

BadgeStyled.propTypes = {
  backgroundColor: string,
  borderRadius: string,
  display: string,
  error: bool,
  fontColor: string,
  onClose: func,
  text: string,
  width: string
};

export default BadgeStyled;
